import { CONDITIONS_LOADED } from "./types";

export const ConditionsLoaded = data => ({
    type: CONDITIONS_LOADED,
    payload: data
  });






  

